import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#4BA9D2',
        secondary: '#5A98B1',
        accent: '#9F9B9B',
        error: '#D7574A',
        success: '#7DAC1E'
      }
    }
  },
  'font-family': 'Rubik'
});
